import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';
import './App.css';

class Navbar extends Component {
  render() {
    return (
      <div class="topnav">
      <NavLink to="/">Home</NavLink>
      <NavLink to="/todos">ToDos</NavLink>
      <NavLink to="addToDo">addToDo</NavLink>
    </div>
    );
  }
}

export default Navbar;
